import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { AlertCircle, X, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

const DISMISS_KEY = "leranio_verify_dismiss_ts";

export default function EmailVerifyBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [resending, setResending] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(0);

  useEffect(() => {
    const ts = parseInt(localStorage.getItem(DISMISS_KEY) || "0", 10);
    if (ts && Date.now() - ts < 24 * 3600 * 1000) setDismissed(true);
  }, []);
  useEffect(() => {
    if (secondsLeft <= 0) return;
    const t = setTimeout(() => setSecondsLeft(secondsLeft - 1), 1000);
    return () => clearTimeout(t);
  }, [secondsLeft]);

  if (!user || user.email_verified || dismissed) return null;

  const resend = async () => {
    setResending(true);
    try {
      await api.post("/auth/resend-verification");
      toast.success("Doğrulama e-postası tekrar gönderildi");
      setSecondsLeft(120);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      if (err?.response?.status === 429) {
        const m = String(detail || "").match(/(\d+)/);
        if (m) setSecondsLeft(parseInt(m[1], 10));
      }
      toast.error(typeof detail === "string" ? detail : "Gönderilemedi");
    }
    setResending(false);
  };

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setDismissed(true);
  };

  return (
    <div role="alert" className="bg-amber-500/10 border-b border-amber-500/30 px-4 py-2.5 flex items-center gap-3 text-sm" data-testid="email-verify-banner">
      <AlertCircle size={16} className="text-amber-600 shrink-0"/>
      <span className="flex-1 text-amber-800 dark:text-amber-300">
        E-postanızı doğrulayın — hesabınıza tam erişim için <b>{user.email}</b> adresine gönderilen bağlantıya tıklayın.
      </span>
      <Button size="sm" variant="outline" onClick={resend} disabled={resending || secondsLeft > 0} className="h-8" data-testid="email-verify-resend-btn">
        {resending ? <Loader2 size={12} className="animate-spin mr-1"/> : null}
        {secondsLeft > 0 ? `${secondsLeft}s` : "Tekrar Gönder"}
      </Button>
      <button onClick={dismiss} aria-label="Uyarıyı kapat" className="p-1 text-amber-700 hover:text-amber-900" data-testid="email-verify-dismiss-btn"><X size={14}/></button>
    </div>
  );
}
